import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../../lib/api';
import ToolHeader from './ToolHeader';
import { IncomingCapture } from '../../scanner/IncomingCapture';
import '../../scanner/scanner.css';

export default function ScannerReviewPage() {
  const { sessionId } = useParams();
  const [session, setSession] = useState(null), [error, setError] = useState('');
  const refresh = useCallback(() => api.get(`/scan-pos/sessions/${sessionId}`).then(r => setSession(r.data)).catch(() => setError('This prescription review is unavailable.')), [sessionId]);
  useEffect(() => { refresh(); const t = setInterval(refresh, 2500); return () => clearInterval(t); }, [refresh]);
  const decide = async (eid, body) => { const { data } = await api.post(`/scan-pos/sessions/${sessionId}/events/${eid}`, body); await refresh(); return data; };
  const act = async fn => { try { await fn(); } catch (e) { toast.error(e.response?.data?.detail || e.message); } };
  return <div className="scan-phone-page" data-testid="scanner-pharmacist-review"><ToolHeader title="Prescription review" back="/staff-app/tools/scan-pos" />
    {error && <p role="alert" data-testid="scanner-review-error">{error}</p>}
    {session && <><header className="scan-connection" data-testid="scanner-review-till">{session.branch_name} · {session.name}<span>Sale {session.sale_ref}</span></header>
      {session.events.filter(e => e.kind === 'photo').map(e => <IncomingCapture key={e.event_id} event={e} scanner={{ session, decide }} reviewOnly act={act} />)}
    </>}
  </div>;
}